/**
 * Advanced line total from user-agreed pricing (scopeOfWork.costOverride) or persisted totals.
 * Not derived from typeOfService.baseRatePerHour.
 */
export function getAdvancedServiceAgreedTotal(service: Record<string, unknown>): number {
  const sw = service.scopeOfWork as Record<string, unknown> | undefined;
  if (!sw) {
    return Number((service as { total?: unknown }).total) || 0;
  }
  const co = sw.costOverride as { value?: unknown; price?: unknown } | undefined;
  const serviceTotal =
    Number(co?.value) ||
    Number(co?.price) ||
    Number(sw.total) ||
    Number((service as { total?: unknown }).total) ||
    0;
  return Number.isFinite(serviceTotal) ? serviceTotal : 0;
}

/**
 * Quote display total for deposit cap / UI (matches QuotesTable advanced logic).
 * Uses grandServiceCostCalc when set; otherwise sums service lines (basic: total; advanced: scopeOfWork cost).
 */
export function getQuoteGrandTotalFromQuote(quote: Record<string, unknown> | null | undefined): number {
  if (!quote) return 0;
  const calc = Number(quote.grandServiceCostCalc) || 0;
  if (calc > 0) return calc;

  const services = Array.isArray(quote.services) ? (quote.services as Record<string, unknown>[]) : [];
  if (services.length === 0) return 0;

  const isBasic = quote.type === "basic";
  if (isBasic) {
    return services.reduce((acc, s) => acc + (Number((s as { total?: unknown }).total) || 0), 0);
  }

  return services.reduce((acc, s) => acc + getAdvancedServiceAgreedTotal(s), 0);
}
